


































import { Vue, Component, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import memberStore from '@/modules/member/member.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import PhoneNumberVerification from '@/modules/member/components/PhoneNumberVerification'
import PhoneNumberConfirmation from '@/modules/member/components/PhoneNumberConfirmation'
import { IdentityAPI } from '@/api/identity'
import { TournamentEntity } from '@/api/tournament'
import { invokeDialogCallback } from '@/utils/verification'

@Component({
  components: {
    PhoneNumberVerification,
    PhoneNumberConfirmation
  }
})
export default class PhoneNumberVerificationDialog extends Vue {
  memberModule = getModule(memberStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  phoneVerificationStep: number = 1
  phoneVerificationSteps: number = 2
  phoneNumber: string = ''

  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get isPhoneVerificationVisible(): boolean {
    return this.memberModule.isPhoneVerificationVisible
  }

  onPhoneVerificationSuccess() {
    invokeDialogCallback().then()
  }

  closePhoneDialog() {
    this.memberModule.setIsPhoneVerificationVisible({ isVisible: false })
    this.phoneVerificationStep = 1
  }

  async phoneVerificationHandler(phoneNumber: string) {
    this.phoneNumber = phoneNumber
    this.phoneVerificationStep = 2
  }

  async phoneConfirmationHandler(verificationCode: string) {
    this.closePhoneDialog()
    this.onPhoneVerificationSuccess()
  }
}
